<div class="row">
    <div class="col-sm-6">
        <div class="row">
            <div class="col"><label class="fw-bold">Select who to send notifications to:</label></div>
        </div>
        <div class="row">
            <div class="col">
                <label>Customer Contacts</label>
                <kendo-multiselect [data]="contactList"
                                   [textField]="'contactName'"
                                   [valueField]="'contactID'"
                                   [(ngModel)]="selectedContacts"
                                   [popupSettings]="{ appendTo: 'component' }">
                </kendo-multiselect>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label>Employees</label>
                <kendo-multiselect [data]="employeeList"
                                   [textField]="'fullName'"
                                   [valueField]="'employeeId'"
                                   [(ngModel)]="selectedEmployees"
                                   [popupSettings]="{ appendTo: 'component' }">
                </kendo-multiselect>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label>Additional Emails</label>
                <span matTooltip="Enter multple emails separated by a comma (',')"><i class="far fa-question-circle text-primary"></i></span>
                <input type="text" class="form-control" [(ngModel)]="quoteOrderEventNotification.additionalEmails" />
                <label class="text-danger">WARNING</label>: Do not send to any distribution list if any of those emails are included in the Employees or Additional Emails.
            </div>
        </div>
    </div>
    <div class="col">
        <div class="row">
            <div class="col"><label class="fw-bold">Select events for notification:</label></div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <div>
                    <input type="checkbox" style="margin: 5px; transform: scale(1.5)" id="orderEventTypeAll" [checked]="isAll" (click)="eventTypeAllClick('All')" />
                    <label class="fw-bold" for="orderEventTypeAll">All</label>
                </div>
                <div>
                    <input type="checkbox" style="margin: 5px; transform: scale(1.5)" id="orderEventTypeAllArv" [checked]="isAllArv" (click)="eventTypeAllClick('Arv')" />
                    <label class="fw-bold" for="orderEventTypeAllArv">ALL Arv</label>
                </div>
                <div>
                    <input type="checkbox" style="margin: 5px; transform: scale(1.5)" id="orderEventTypeAllDep" [checked]="isAllDep" (click)="eventTypeAllClick('Dep')" />
                    <label class="fw-bold" for="orderEventTypeAllDep">ALL Dep</label>
                </div>
            </div>
            <div class="col">
                <div *ngFor="let eventType of orderEventTypeList">
                    <input type="checkbox" style="margin: 5px; transform: scale(1.5)" id="orderEventType{{eventType.orderEventTypeID}}" [checked]="isEventChecked(eventType)" (click)="eventTypeClick(eventType)" />
                    <label class="fw-bold" for="orderEventType{{eventType.orderEventTypeID}}">{{eventType.code}}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <button type="button" class="btn btn-primary" (click)="saveQuotOrderEventNotification()">Save</button>
            </div>
        </div>
    </div>
</div>
